<template>
  <div v-if="butShow&&route">
    <div @click="handleOpen" class="chat-open">
      <span class="chat-open-text">{{$i18.language("内部反馈")}}</span>
    </div>
    <el-dialog append-to-body width="38%" :title="$i18.language('内部反馈')" :visible.sync="Dataerrorcorrection" destroy-on-close>
      <el-form :rules="rules" ref="formdata" :model="formdata" label-width="110px">
        <el-form-item :label="$t('companyDetail.replyEmail')" prop="emaile">
          <el-input :placeholder="$t('companyDetail.enterEmail')" v-model="formdata.emaile"></el-input>
        </el-form-item>
        <el-form-item :label="$t('companyDetail.contactPhone')" prop="telephone">
          <el-input :placeholder="$t('companyDetail.enterPhone')" v-model="formdata.telephone"></el-input>
        </el-form-item>
        <el-form-item :label="$i18.language('附件:')">
          <el-upload
            class="upload-demo"
            :headers="headers"
            :action="`/api/help/file/uploadFile`"
            :on-remove="handleRemove"
            :on-success="handleChange"
            :before-upload="beforeUpload"
            :limit="3"
            :on-exceed="handleExceed"
            multiple
            :file-list="formdata.fileList">
            <el-button class="confirm-btn">{{$i18.language('点击上传')}}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('companyDetail.questionDse')" prop="desc">
          <el-input :rows="6" type="textarea" :maxlength="280" :placeholder="$i18.language('请简要描述一下当前页面中，对于内容/数据的疑问。最多输入280个字符。')" v-model="formdata.desc"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="sub-confirm-btn" @click="Dataerrorcorrection = false">{{ $t('cancel') }}</el-button>
        <el-button class="confirm-btn" @click="confirmMtji('formdata')">{{ $t('submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'userFeedback',
  computed: {
    accountInfo() {
      return localStorage.getItem("set_account_info")?JSON.parse(localStorage.getItem("set_account_info")):this.$store.getters.accountInfo;
    },
    route() {
      let path = this.$route.path
      // 账户中心和BI不展示该按钮
      let auth = /\/user|\/biAnalysis|\/report\//.test(path)
      return !auth
    }
  },
  watch: {
    'accountInfo.role_type': {
      handler(val) {
        // 内部账户展示该按钮，1客户账户，2内部账户
        this.butShow = (val==2 )
      },
      immediate: true,
    },
  },
  data() {
    return {
      formdata: {
        emaile: '',
        telephone: '',
        desc: '',
        fileList: [],
        filePaths: [],
      },
      butShow: false,
      headers: {
        Unionkey: 'gt6',
        Website: this.$util.getCurrentWebSite(),
        language: localStorage.getItem("language") || 'zh',
        Authorization: localStorage.getItem("accessToken"),
      },
      Dataerrorcorrection: false,
      rules: {
        // emaile: [{ required: true, message: this.$i18.language('请输入回复邮箱'), trigger: 'blur' }],
        // telephone: [{ required: true, message:this.$i18.language('请输入联系电话'), trigger: 'blur' }],
        desc: [{ required: true, message: this.$i18.language('请输入问题描述'), trigger: 'blur' }],
      },
    }
  },
  mounted() {
  },
  methods: {
    // 打开用户反馈
    handleOpen() {
      this.Dataerrorcorrection = true
    },
    // 上传移除文件
    handleRemove(file, fileList) {
      console.log(file, this.formdata.fileList);
      const index = this.formdata.fileList.findIndex(item => item.uid === file.uid);
      this.formdata.filePaths.splice(index, 1)
      this.formdata.fileList = fileList
      console.log(this.formdata.filePaths);
    },
    // 超出上传限制
    handleExceed(files, fileList) {
      this.$message.warning(this.$i18.language('限制最多上传三张图片'));
    },
    handleChange(res, file, fileList) {
      if(res.code == 200) {
        let {path} = res.data
        this.formdata.fileList = fileList
        this.formdata.filePaths.push(path)
        console.log(this.formdata.filePaths);
      }
    },
    beforeUpload(file) {
      const isJPG = /(jpg|jpeg|png|gif)$/i.test(file.type);
      const isLt = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.warning(this.$i18.language('只能上传图片'));
      }
      if(!isLt) {
        this.$message.warning(this.$i18.language('上传不能超过10M'));
      }
      return isJPG&&isLt;
    },
    // 保存用户反馈信息
    confirmMtji(formdata) {
      this.$refs[formdata].validate(async (valid) => {
        if (valid) {
          let {emaile, telephone, desc, filePaths} = this.formdata
          const data = {
            id: "",
            type: 11, //1特易搜搜，2贸易情报
            emaile,
            telephone,
            data: desc,
            filePaths,
            pageUrl: location.href
          }
          let res = await this.$api.dashboard.saveMyDataCorrection(data)
          if (res.code == 200) {
            this.Dataerrorcorrection = false
            this.$message({
              type: 'success',
              message: this.$i18.language('反馈成功'),
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-open {
  position: fixed;
  right: -0;
  bottom: 80px;
  cursor: pointer;
  z-index: 9999;
  background: #ffffff;
  display: inline-block;
  padding: 6px 12px;
  color: $--color-font;
  box-shadow: 0px 0px 2px 0px rgba(85,107,130,0.16), 0px 2px 4px 0px rgba(85,107,130,0.16);
  border-radius: 8px;
}
@keyframes myfirst {
  0% {
    top: 40vh;
  }
  25% {
    top: 50vh;
  }
  50% {
    top: 60vh;
  }
  75% {
    top: 40vh;
  }
  100% {
    top: 30vh;
  }
}
@-webkit-keyframes myfirst /* Safari and Chrome */ {
  0% {
    top: 40vh;
  }
  25% {
    top: 50vh;
  }
  50% {
    top: 60vh;
  }
  75% {
    top: 50vh;
  }
  100% {
    top: 40vh;
  }
}
</style>